import React, { useState } from 'react';
import { useRouter } from 'next/router';

import './CommunityLeaveGroupPopupContent.scss';
import { getString } from '../../../../helpers/styles';
import icons from '../../../../shared/assets/icons/redesign';

const { Check, Logout } = icons;

const reasonList = ['Niet relevant', 'Te veel reclame', 'Te veel notificaties'];

export default function CommunityLeaveGroupPopupContent({
  onClose,
  group,
  userLeaveGroup
}) {
  const router = useRouter();
  const [activeItem, setActiveItem] = useState();

  return (
    <>
      <div className="popup-header">
        <h4 className="communityLeaveGroupPopup-title">
          <Logout className="communityLeaveGroupPopup-title-icon" />
          Groep verlaten
        </h4>

        <button className="popup-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="popup-body">
        <p className="communityLeaveGroupPopup-text">
          Je staat op het punt de groep te verlaten. Weet je dit zeker?
        </p>

        <ul className="community-list">
          {reasonList.map((item) => (
            <li
              key={item}
              className={getString([
                {
                  value: 'community-list-item',
                  condition: true
                },
                {
                  value: 'community-list-item-active',
                  condition: activeItem === item
                }
              ])}
              onClick={() => setActiveItem(item)}
            >
              <label className="community-item-label">
                <input
                  type="radio"
                  className="community-radio-input"
                  checked={activeItem === item}
                  onChange={() => {}}
                />

                <span className="community-checkmark">
                  <Check className="community-checkmark-icon" />
                </span>

                {item}
              </label>
            </li>
          ))}
        </ul>

        <button
          onClick={onClose}
          className="popup-button popup-button-secondary"
        >
          Terug
        </button>

        <button
          onClick={() => (
            userLeaveGroup({
              variables: { userGroupXuid: group.xuid, reason: activeItem }
            }),
            router.push('/')
          )}
          className={getString([
            {
              value: 'popup-button popup-button-primary',
              condition: true
            },
            {
              value: 'popup-button-disabled',
              condition: !activeItem
            }
          ])}
        >
          Verlaten
        </button>
      </div>
    </>
  );
}
